<template>
    <el-card class="box-card" shadow="hover">
        <div slot="header" class="clearfix">
            <span>每日自选套餐{{ search.status == 1 ? '登记人数' : '预约人数' }} <small>(合计：{{ total }}人)</small></span>
            <el-form :inline="true" :model="form" style="float:right">
                <!-- <el-form-item label="预约日期">
                    <el-date-picker v-model="form.daterange" size="mini" type="daterange" range-separator="至"
                    style="width: 240px"
                        start-placeholder="开始日期" value-format="yyyy-MM-dd" end-placeholder="结束日期">
                    </el-date-picker>
                </el-form-item> -->
                <el-button style="padding: 3px 0" type="text" @click="getData" icon="el-icon-refresh"></el-button>
            </el-form>
        </div>
        <v-chart autoresize ref="chart" :option="option" style="height: 200px" v-loading="loading"></v-chart>
    </el-card>
</template>

<script>
export default {
    name: 'statAppointZixuanDates',
    props: {
        search: {
            type: [Object],
            default: () => { }
        }
    },
    data() {
        return {
            loading: false,
            form: { daterange: [] },
            total: 0,
            option: {
                grid: {
                    top: 20,
                    bottom: 20,
                    left: 50,
                    right: 15
                },
                tooltip: {
                    trigger: 'item',
                    formatter: '{b}: {c}人'
                },
                xAxis: {
                    type: 'category',
                    data: []
                },
                yAxis: {
                    type: 'value'
                },
                series: [
                    {
                        data: [],
                        type: 'bar',
                        color: '#1890ff',
                        label: {
                            show: true, //开启显示
                            position: 'top', //在上方显示
                            color: 'black',
                            fontSize: 12
                        }
                    }
                ]
            }

        }
    },
    methods: {
        async getData() {
            this.loading = true
            const resp = await this.$http.get('/components/charts/statistics/appoint/zixuandates', { params: this.search })
            this.option.xAxis.data = []
            this.option.series[0].data = []
            this.total = 0
            resp.data.forEach(e => {
                this.option.xAxis.data.push(e.name.slice(5))
                this.option.series[0].data.push(e.total)
                this.total += e.total
            })
            this.$refs['chart'].setOption(this.option)
            this.loading = false
        }
    },
    mounted() {
        this.getData().then(() => {
        })
    }
}
</script>
